<div class="mui-input__control-wrapper">
  <div class="mui-input__leading" *ngIf="icon" aria-hidden="true">
    <i mui-icon [name]="icon" [font]="iconFont" class="mui-input__leading__icon fa-fw"></i>
  </div>
  <ng-content select="input, select, textarea, .mui-input__control"></ng-content>
  <div *ngIf="isTextarea && label" class="mui-input__label-bg"></div>
  <!--suppress XmlInvalidId -->
  <label
    class="mui-input__label"
    *ngIf="label"
    [attr.for]="labelFor ?? muiInput?.id ?? null"
    [attr.id]="labelId">
    <span class="mui-input__label__text">{{ label }}</span>
    <span class="required" *ngIf="isControlRequired" aria-hidden="true"> &#42;</span>
    <span
      class="mui-input__popover"
      closeDelay="50"
      *ngIf="popoverText"
      [attr.data-qa]="'mui-input-popover'"
      [placement]="popoverPlacement"
      [muiPopover]="popoverText">
      <i mui-icon font="fa" name="info-circle"></i>
    </span>
  </label>
  <div class="mui-input__trailing mui-input__trailing-icon" *ngIf="hasTrailingIcon && !isPassword" aria-hidden="true">
    <i
      *ngIf="!isControlValid && !isSelect"
      mui-icon
      name="exclamation-triangle"
      font="fa"
      class="mui-input__trailing__error-indicator fa-fw"></i>
    <i *ngIf="isSelect" mui-icon name="chevron-down" font="fa" class="mui-input__trailing__chevron fa-fw"></i>
  </div>
  <div
    *ngIf="isPassword"
    (click)="togglePwd()"
    role="button"
    class="mui-input__trailing"
    [attr.aria-label]="showPassword
       ? (hidePasswordButtonLabel ?? (translations$ | async)?.hidePasswordButton)
       : (showPasswordButtonLabel ?? (translations$ | async)?.showPasswordButton)">
    <i
      mui-icon [name]="showPassword ? 'eye' : 'eye-slash'" font="fa" class="mui-input__trailing__eye fa-fw"
      aria-hidden="true"></i>
  </div>
  <div
    *ngIf="isResettable && muiInput?.value"
    (click)="resetInput()"
    role="button"
    aria-label="reset"
    class="mui-input__trailing"
  >
    <i
      mui-icon [name]="'times'" font="fa" class="mui-input__times fa-fw"
      aria-hidden="true"></i>
  </div>
  <ng-content></ng-content>
</div>
<div *ngIf=" !displayErrorMessages() && muiFormFieldHint" [id]="muiInput?.id + '-hint'">
  <ng-content select="mui-form-field-hint"></ng-content>
</div>
<div
  *ngIf="displayErrorMessages()"
  [id]="muiInput?.id + '-hint'"
  class="mui-input__error"
  aria-live="polite">
  <ng-content select="mui-form-field-error"></ng-content>
</div>
<div>
  <ng-content select="mui-password-checker"></ng-content>
</div>
